var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#DCFAE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7502 27.9987L26.2502 31.4987L33.2502 24.4987M39.6668 27.9987C39.6668 34.442 34.4435 39.6654 28.0002 39.6654C21.5568 39.6654 16.3335 34.442 16.3335 27.9987C16.3335 21.5554 21.5568 16.332 28.0002 16.332C34.4435 16.332 39.6668 21.5554 39.6668 27.9987Z",
    stroke: "#079455",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f2117fb564d15d6aeee1ca8aada8eb27.svg";
export { ForwardRef as ReactComponent };